import { AppShell } from "@climatepartner/app-shell";
import { Toast } from "@climatepartner/components/Toast";
import { RouteObject } from "react-router-dom";

import { UserProvider } from "../../../shared/auth/user-provider";
import { APP_SERVICE_IDS } from "../../../shared/config/app-services";
import { ENVIRONMENT } from "../../../shared/config/environment";
import { monitoringConfig } from "../../../shared/monitoring/monitoring-config";
import { NETWORK_SUPPLIER_SELECT_ACCOUNT_PATH } from "../../../shared/routing/paths/network";
import { themePalette } from "../../../shared/ui/theme-palette";
import { AccountSelectionPage } from "./registration/components/account-selection-page";
import { FullPageInviteLayout } from "./registration/components/full-page-invite-layout";

const env = process.env.NODE_ENV === "production" ? "prod" : "dev";

/**
 * Unlike SupplierPublicRoutes, this route mounts its own AppShell so it runs the real Frontegg auth
 * gate: logged-out users are redirected to Frontegg login and returned here with cr/token intact.
 * `layout` (app-shell 33.7.0) keeps the full-page invite hero instead of the app nav/sidebar.
 * UserProvider bridges the session's accessToken onto ccfApiClient so the authenticated
 * resolve/commit calls carry the bearer token.
 */
export const SupplierSelectAccountRoutes: RouteObject = {
  path: NETWORK_SUPPLIER_SELECT_ACCOUNT_PATH,
  element: (
    <AppShell
      theme={themePalette}
      fronteggEnvironment={ENVIRONMENT}
      currentServiceId={APP_SERVICE_IDS.NETWORK}
      config={{ localize: { serviceId: APP_SERVICE_IDS.NETWORK, env }, monitoring: monitoringConfig }}
      layout={FullPageInviteLayout}
    >
      <UserProvider>
        <AccountSelectionPage />
      </UserProvider>
      <Toast />
    </AppShell>
  ),
};
